import webDesign from "../images/webdev.json";
import uiux from "../images/ui_ux.json";
import graphic from "../images/graphic.json";
import database from "../images/database.json";
import Card from "./Card";
import Aos from 'aos'
import { useEffect } from "react";
import 'aos/dist/aos.css'
const Services = () => {

  
  
  const data = [
    {
      title: "UI/UX Design",
      icon: uiux,
    },
    {
      title: "Web Development",
      icon: webDesign,
    },
    {
      title: "Graphic Design",
      icon: graphic,
    },
    {
      title: "Database Management",
      icon: database,
    },
  ];

  useEffect(() => {
    Aos.init({duration:2000})
  }, [])
  return (
    <div className="p-3 mt-4 overflow-hidden" data-aos='fade-up'>
      <h1 className="sm:text-5xl text-3xl font-bold text-center w-full mb-8">
        Our Services
      </h1>
      <div className="grid overflow-hidden gap-4 lg:grid-cols-4 md:grid-cols-2 sm-grid-cols-1 place-items-center">
        {data.map((item, i) => {
          return <Card key={i} index={i} title={item.title} icon={item.icon} />;
        })}
      </div>
    </div>
  );
};
export default Services;
